import React, { useState, useEffect, useMemo } from 'react';
import { number, func, bool, object } from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import TipoElementoValorGrid from '../TipoElementoValorGrid';
import { CloneObject } from '../../../utils/helpers';
import { getDateNow } from '../../../utils/convert';
import {TIPS} from "../../../consts/tips";

import { useFormErrors } from '../../hooks/useFormErrors';
import { FormError, FormLabel, InputLista, InputNumber, Modal } from '../../common';
import { isNull, isValidNumber } from '../../../utils/validator';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const TipoElementoModal = (props) => {

    //variables
    const entityInit = {
        tipoElemento: {
            id: 0,
            idClaseElemento: 0,
            codigo: '',
            orden: '',
            nombre: '',
            idUnidadMedida: 0
        },
        tipoElementoValores: []
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
        showInfo: false
    });

    const mount = () => {

        if (props.id > 0) {
            FindTipoElemento();
        }
   
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const valores = useMemo(() => {
        if (!isNull(state.entity.tipoElementoValores)) {
            return state.entity.tipoElementoValores.filter(x => x.state !== 'r');
        }
        else {
            return [];
        }
    }, [state.entity])

    const valorVigente = useMemo(() => {
        const today = getDateNow();
        const current = valores.find(f => (isNull(f.fechaDesde) || f.fechaDesde <= today) &&
                                          (isNull(f.fechaHasta) || f.fechaHasta >= today));
        return current ? current.valor : 0;
    },[valores]);

    const [ formValues, formHandle, , formSet ] = useForm({
        idUnidadMedida: 0,
        codigo: '',
        orden: '',
        nombre: ''
    });


    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const handleClickAceptar = () => {
        if (validate() && areValoresValid()) {
            if (props.id == 0) {
                AddTipoElemento();
            }
            else {
                ModifyTipoElemento();
            }
        };
    };
    const handleClickCancelar = () => {
        props.onDismiss();
    }
    
    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  

    // funciones
    function getErrors() {

        const errors = {};

        if (formValues.nombre.length === 0) errors.nombre = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.codigo.length === 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED;
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.idUnidadMedida <= 0) errors.idUnidadMedida = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    function getFormatErrors() {

        const errors = {};
        if (props.disabled) return errors;

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero';

        return errors;
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0;
    }

    function areValoresValid() {

        if (state.entity.tipoElementoValores.length <= 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe ingresar un Valor');
            return false;
        }

        const valores = state.entity.tipoElementoValores.filter(item => item.state !== "r");
        for (let i=0; i < valores.length; i++) {
            const current = valores[i];
            if (!isNull(current.fechaDesde) && !isNull(current.fechaHasta) && (current.fechaDesde > current.fechaHasta)) {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe ingresar un rango de fechas correcto');
                return false;  
            }

            if (i > 0) {
                const previous = valores[i-1];
                if (isNull(current.fechaDesde) || isNull(previous.fechaHasta) || previous.fechaHasta >= current.fechaDesde) {
                    ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Los rangos de fechas no deben solaparse');
                    return false;  
                }
            }
        }

        return true;
    }   
    
    function FindTipoElemento() {
    
        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {

                data.tipoElementoValores.forEach(item => {
                    item.fechaDesde = !isNull(item.fechaDesde) ? new Date(item.fechaDesde) : null;
                    item.fechaHasta = !isNull(item.fechaHasta) ? new Date(item.fechaHasta) : null;
                });

                setState(prevState => {
                  return {...prevState, loading: false, entity: data};
                });
                formSet({
                    idUnidadMedida: data.tipoElemento.idUnidadMedida,
                    codigo: data.tipoElemento.codigo,
                    orden: data.tipoElemento.orden,
                    nombre: data.tipoElemento.nombre
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/${props.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_ELEMENTO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }
    
    function AddTipoElemento() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveTipoElemento(method, paramsUrl);
    }
    
    function ModifyTipoElemento() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveTipoElemento(method, paramsUrl);
    }    

    function SaveTipoElemento(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });

            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };
    
        const dataBody = {
            tipoElemento: {
                id: props.id,
                idClaseElemento: props.claseElemento.id,
                codigo: formValues.codigo,
                orden: parseInt(formValues.orden),
                nombre: formValues.nombre,
                idUnidadMedida: formValues.idUnidadMedida
            },
            tipoElementoValores: state.entity.tipoElementoValores.filter(f => f.state !== 'o')
        };

        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.TIPO_ELEMENTO,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }

    function updateTablaItem(row) {
        let entity = CloneObject(state.entity);
        
        if (row.state === 'a') {
            entity.tipoElementoValores.push(row);
        }
        else if (row.state === 'm') {
            const index = entity.tipoElementoValores.indexOf(entity.tipoElementoValores.find(x => x.id === row.id));
            if (index !== -1) {
                if (row.id < 0) row.state = 'a'; //originalmente era un alta
                entity.tipoElementoValores[index] = row;
            }
        }
        else if (row.state === 'r') {
            if (row.id < 0) { //lo elimino directamente porque no existe en la bd
                entity.tipoElementoValores = entity.tipoElementoValores.filter(f => f.id !== row.id);
            }
            else {
                let item = entity.tipoElementoValores.find(x => x.id === row.id);
                item.state = 'r';
            }
        }
    
        setState(prevState => {
            return {...prevState,
                entity: entity
            };
        });
      }

  return (
    <>

    <Modal
      size="lg"
      title={`Tipo elemento: ${(props && props.id > 0) ? state.entity.tipoElemento.nombre : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.TIPO_ELEMENTO_MODAL}
      onEscape={handleClickCancelar}
      body={(<>
            <div className="row form-basic">
                <div className="mb-3 col-12">
                    <label htmlFor="claseElemento" className="form-label">Clase elemento</label>
                    <input
                        name="claseElemento"
                        placeholder=""
                        className="form-control"
                        value={ props.claseElemento ? props.claseElemento.nombre : "" }
                        disabled={ true }
                    />
                </div>
            </div>
            <div className="row form-basic">
                <div className="mb-3 col-12 col-md-4">
                    <FormLabel htmlFor="codigo" required>Código</FormLabel>
                    <input
                        name="codigo"
                        placeholder=""
                        className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                        value={ formValues.codigo }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('codigo')} />
                </div>
                <div className="mb-3 col-12 col-md-8">
                    <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                    <input
                        name="nombre"
                        type="text"
                        placeholder=""
                        className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                        value={ formValues.nombre }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('nombre')} />
                </div>
                <div className="mb-3 col-12 col-md-4">
                    <FormLabel htmlFor="idUnidadMedida" required>Unidad de medida</FormLabel>
                    <InputLista
							name="idUnidadMedida"
							placeholder=""
							className={`form-control ${errorOf('idUnidadMedida') ? 'is-invalid' : ''}`}
							value={ formValues.idUnidadMedida }
                            onChange={ formHandle }
							disabled={ props.disabled }
							title="Unidad de medida"
							lista="UnidadMedida"
                    />
                    <FormError message={errorOf('idUnidadMedida')} />
                </div>
                <div className="mb-3 col-6 col-md-4">
                    <FormLabel htmlFor="orden" required>Orden</FormLabel>
                    <input
                        name="orden"
                        type="number"
                        placeholder=""
                        className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                        value={ formValues.orden }
                        onChange={ formHandle }
                        disabled={ props.disabled }
                    />
                    <FormError message={errorOf('orden')} />
                </div>
				<div className="mb-3 col-6 col-md-4">
                    <label htmlFor="valorVigente" className="form-label">Valor vigente</label>
                    <InputNumber
                        name="valorVigente"
                        placeholder=""
                        className="form-control"
                        value={ valorVigente }
                        precision={2}
                        disabled={ true }
                    />
                </div>
            </div>
            <div className="row form-basic">
                <TipoElementoValorGrid
                    disabled={props.disabled}
                    data={{
                        idTipoElemento: state.entity.tipoElemento.id,
                        list: valores
                    }}
                    onChange={row => {
                        updateTablaItem(row)
                    }}
                />
            </div>
      </>)}
      footer={!props.disabled ? (<>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
            <button className="btn back-button" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

TipoElementoModal.propTypes = {
    disabled: bool,
    id: number.isRequired,
    claseElemento: object,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

TipoElementoModal.defaultProps = {
    disabled: false,
    claseElemento: null
};

export default TipoElementoModal;